import { supabase } from '../lib/supabase';

const TABLE_NAME = 'order_form_templates';

// Get order form template
export const getOrderFormTemplate = async () => {
  try {
    const { data, error } = await supabase
      .from(TABLE_NAME)
      .select('*')
      .eq('template_type', 'order_form')
      .single();

    if (error && error.code !== 'PGRST116') throw error; // PGRST116 is "not found"
    return data || getDefaultOrderFormTemplate();
  } catch (error) {
    console.error('Error fetching order form template:', error);
    // Fallback to default template if DB fetch fails
    return getDefaultOrderFormTemplate();
  }
};

// Create or update order form template
export const saveOrderFormTemplate = async (templateData) => {
  try {
    // Check if template exists
    const { data: existing } = await supabase
      .from(TABLE_NAME)
      .select('id')
      .eq('template_type', 'order_form')
      .maybeSingle();

    if (existing) {
      // Update existing template
      const { data, error } = await supabase
        .from(TABLE_NAME)
        .update({
          subject: templateData.subject,
          body: templateData.body,
          updated_at: new Date().toISOString(),
        })
        .eq('id', existing.id)
        .select()
        .single();

      if (error) throw error;
      return data;
    } else {
      // Create new template
      const { data, error } = await supabase
        .from(TABLE_NAME)
        .insert([{
          template_type: 'order_form',
          subject: templateData.subject,
          body: templateData.body,
        }])
        .select()
        .single();

      if (error) throw error;
      return data;
    }
  } catch (error) {
    console.error('Error saving order form template:', error);
    throw error;
  }
};

// Get default order form template
export const getDefaultOrderFormTemplate = () => {
  return {
    template_type: 'order_form',
    subject: 'Glass Order {{order_number}} - {{to}}',
    body: `MENLO ATHERTON GLASS COMPANY
PO BOX 5214
Redwood City CA 94063
650-322-1116 Phone
Heather@menloathertonglass.com

Our P.O.: {{our_po}}
{{order_number}}

To: {{to}}

{{sales_associate}}
Sales Associate
{{order_date}}
Order Date

{{service_type}}

Description: {{description}}
Quantity / Dimensions / Thickness: {{quantity_dimensions}}
Specifications: {{specifications}}

Comments:
{{comments}}`,
  };
};
